export function paramsToQueryIdentifier(params) {
  return JSON.stringify(params);
}
